'use client'

import { Reveal } from 'react-awesome-reveal'
import React from 'react'
import { keyframes } from '@emotion/react'
import classNames from 'classnames'

export interface AppearProps {
  children?: React.ReactNode
  cascade?: boolean
  delay?: number
  className?: string
}

const customAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const Appear = (props: AppearProps) => {
  const className = classNames('appear', props.className)

  return (
    <Reveal className={className} keyframes={customAnimation} duration={1500} cascade={props.cascade} delay={props.delay} damping={.1} triggerOnce>
      {props.children}
    </Reveal>
  )
}

export default Appear